import React from 'react'
import InputCustomStyles from './child/InputCustomStyles'

const FormValidationLayer = ({ isEditMode = false, brandId = null }) => {
    return (
        <div className="row gy-4">
            {/* InputCustomStyles */}
            <InputCustomStyles isEditMode={isEditMode} brandId={brandId} />
        </div>
    )
}

export default FormValidationLayer